import React from "react";
import "../App.scss";

const Now = () => (
  <div className="now">
    <div className="now_section">
      <h2 className="title">What I'm doing now</h2>
    </div>
    <div className="now_section">
      <h3>
        Personal{" "}
        <span role="img" aria-label="emoji">
          🐶
        </span>
      </h3>
      <p>
        Anna and I moved in together this year. It is our biggest change yet.
        Living together has strengthened our bond and taught us to communicate
        better while connecting more deeply. Kiba our mini schnauzer is loving
        it the most and thriving with us both under one roof.
      </p>

      <h3>
        Work{" "}
        <span role="img" aria-label="emoji">
          👨‍💻
        </span>
      </h3>
      <p>
        I’m actively looking for a new role as a Frontend Engineer, focusing on
        React, TypeScript, and Tailwind after five years at SAP. My goal is to
        join a team where we can build impactful, user- and mission-focused
        products. If you’re hiring or know someone who is, I’d love to chat
        – you can reach me at{" "}
        <a href="mailto:chan@hey.com" target="_blank" rel="noreferrer noopener">
          chan@hey.com
        </a>
        .
      </p>

      <h3>
        Travels{" "}
        <span role="img" aria-label="emoji">
          ✈️
        </span>
      </h3>
      <p>
        Last year was packed with adventure. I took my parents and fiancée to
        Japan – their first time. Seeing them light up in Tokyo’s busy streets
        and Kyoto’s quiet temples warmed my heart. Anna and I also explored
        Asia: Thailand’s lively markets, Vietnam’s stunning views, China’s
        ancient sites, and a second Japan trip that felt just as special.
      </p>

      <h3>
        Running{" "}
        <span role="img" aria-label="emoji">
          🏃‍♂️
        </span>
      </h3>
      <p>
        Last year I trained harder than ever and ran my fastest marathon yet – 3
        hours 32 minutes, my 10th marathon. I’m really proud of that. When I
        started with the San Francisco Marathon in 2012, which was a brutal
        race, I never thought I’d run this many. I’ve come to love running’s
        peacefulness. I’m taking a break now, with no plans for another marathon
        soon, to focus on other priorities.
      </p>

      <h3>
        Study abroad reunion{" "}
        <span role="img" aria-label="emoji">
          🙂
        </span>
      </h3>
      <p>
        We rarely plan reunions nowadays since everybody have their own travel
        plans. We let things happen naturally. It's become more difficult as
        years go by. This was expected.
      </p>

      <h3>
        Writings{" "}
        <span role="img" aria-label="emoji">
          📝
        </span>
      </h3>
      <p>
        I am experimenting writing in a private journal, but my blog still
        remains online:{" "}
        <a
          rel="noreferrer noopener"
          href="https://notyourtypicalasian.com"
          target="_blank"
        >
          <strong>www.notyourtypicalasian.com</strong>
        </a>
        . I will come back to blogging at some point in the near future.
      </p>
    </div>
    <div className="now_section">
      <p>
        <em>Last updated June 26, 2025.</em>
      </p>
    </div>
  </div>
);

export default Now;
